/**
 * Vuex module for installation-level project settings.
 * Controls which modules, menu groups, forms, and fields are visible.
 * Loaded once at login from /api/auth/profile → projectSettings.
 */
export const state = {
  modules: {},
  groups: {},
  forms: {},
  fields: {},
};

export const getters = {
  isModuleEnabled: (state) => (moduleKey) => {
    return state.modules[moduleKey]?.enabled !== false;
  },

  isGroupEnabled: (state) => (groupKey) => {
    const group = state.groups[groupKey];
    if (!group) return true;
    if (!group.enabled) return false;
    return state.modules[group.moduleKey]?.enabled !== false;
  },

  isFormEnabled: (state, getters) => (formGroupKey) => {
    const form = state.forms[formGroupKey];
    if (!form) return true;
    if (!form.enabled) return false;
    if (form.groupKey && !getters.isGroupEnabled(form.groupKey)) return false;
    return state.modules[form.moduleKey]?.enabled !== false;
  },

  isFieldVisible: (state) => (formGroupKey, fieldKey) => {
    return state.fields[formGroupKey]?.[fieldKey]?.visible !== false;
  },

  isFieldRequired: (state) => (formGroupKey, fieldKey) => {
    return state.fields[formGroupKey]?.[fieldKey]?.required === true;
  },

  fieldLabel: (state) => (formGroupKey, fieldKey, defaultLabel) => {
    return state.fields[formGroupKey]?.[fieldKey]?.label || defaultLabel;
  },

  formDisplayName: (state) => (formGroupKey, defaultName) => {
    return state.forms[formGroupKey]?.displayName || defaultName;
  },
};

export const mutations = {
  SET_SETTINGS(state, settings) {
    state.modules = settings.modules || {};
    state.groups = settings.groups || {};
    state.forms = settings.forms || {};
    state.fields = settings.fields || {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
